import { StateContext } from '@ngxs/store';

import { ReferralsRewardRepo } from '../../referrals/admin/reward/reward.repository';
import { ReferralsApplicationRepo } from '../../referrals/portal/application/application.repository';
import { ReferralsQuestionsRepo } from '../../referrals/portal/questions/questions.repository';
import { EntitySaveMany } from './entity-state-actions';

enum References {
  ReferralTemplate = 'ReferralTemplate',
  ReferralReward = 'ReferralReward',
  ReferralApplication = 'ReferralApplication',
}

export const referencesReposMap = {
  [References.ReferralTemplate]: ReferralsQuestionsRepo,
  [References.ReferralReward]: ReferralsRewardRepo,
  [References.ReferralApplication]: ReferralsApplicationRepo,
};

export function dispatchReferencesByType(
  ctx: StateContext<any>,
  references: Partial<{ type: string }>[],
): void {
  const refGroups: Record<string, any> = references.reduce<Record<string, any>>((acc, item) => {
    const arr = acc[item.type!] || [];
    return { ...acc, [item.type!]: [...arr, item] };
  }, {});
  Object.entries(refGroups).map(([refType, refs]: [References, any]) => {
    ctx.dispatch(new EntitySaveMany(referencesReposMap[refType], refs));
  });
}
